import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { DateUtils } from '@/common/utils/DateUtils';
import { useEffect, useState } from 'react';
import { ProgTierCalcType } from './formFields/ProgTierCalcType';
import { ProgDateBasis } from './formFields/ProgDateBasis';
import { ProgPeriodicity } from './formFields/ProgPeriodicity';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { endDateValidator, startDateValidator } from '@/common/form/validators/dateValidators';

export const ProgForm = () => {

  const rsrc = useRsrc();
  const { entityObj } = useEntityMgr();
  const [ctrtObj, setCtrtObj] = useState(null);

  // Contract object is important for validations
  useEffect(() => {
    // When creating a new Program, the reference to the contract comes in the NavState, 
    // otherwise we get it from the existing EntityObj
    let ctrtId = entityObj.ctrtId;
    rsrc.byId('md', 'CTRT', ctrtId).then(res => setCtrtObj(res));
  }, []);

  // Don't render until we have the contract
  if (!ctrtObj) return <></>;

  const augFieldDefs = (fieldToFieldDef) => {

    fieldToFieldDef.startDate.validators = [
      (value) => {
        return value >= ctrtObj.startDate ? null : `Start date must be on or after Contract start date (${DateUtils.format(ctrtObj.startDate)})`
      },
      startDateValidator
    ];
  
    fieldToFieldDef.endDate.validators = [
      (value) => {
        return value <= ctrtObj.endDate ? null : `End date must be on or before the Contract end date (${DateUtils.format(ctrtObj.endDate)})`
      },
      endDateValidator
    ]

    if (ctrtObj.type === 'MCD') {
      delete fieldToFieldDef.custId;
    }

    if (ctrtObj.type !== 'DIST') {
      delete fieldToFieldDef.bidAwardCode
    }

    fieldToFieldDef.tierCalcType.component = <ProgTierCalcType fieldDef={fieldToFieldDef.tierCalcType}/>;
    fieldToFieldDef.dateBasis.component = <ProgDateBasis fieldDef={fieldToFieldDef.dateBasis} />;
    fieldToFieldDef.pymtPeriodicity.component = <ProgPeriodicity fieldDef={fieldToFieldDef.pymtPeriodicity} />;
  }

  return (
    <EntityForm entity="PROG" augFieldDefs={augFieldDefs} />
  )
}